import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/user/types'
import UserEntity, { IUserProps } from '@/entities/User'
import { IResponseProps } from '@/entities/Response'

export default class UserRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  set data(value: IResponseProps<IUserProps>) {
    this.store.commit(new types.Store(value))
  }

  get data(): IResponseProps<IUserProps> {
    return this.store.state.user.response
  }

  set current(value: IUserProps | null) {
    this.store.commit(new types.Current(value))
  }

  get current(): IUserProps | null {
    return this.store.state.user.current
  }

  get entity(): UserEntity {
    return new UserEntity(this.store.state.user.current)
  }

  set scrollTop(value: number) {
    this.store.commit(new types.ScrollTop(value))
  }

  get scrollTop(): number {
    return this.store.state.user.scrollTop
  }

  set filter(value: string) {
    this.store.commit(new types.Filter(value))
  }

  get filter(): string {
    return this.store.state.user.filter
  }
}
